import React, { useState } from 'react';
import classNames from 'classnames';
import QuotePostLineContext from './QuotePostLineContext';

const QuotePostLine = ({ children, expanded, onExpand, quoteId, className, ...rest }) => {
  const [hasSecondary, setHasSecondary] = useState(false);

  const handleToggle = event => {
    event.preventDefault();
    event.stopPropagation();
    if (
      event.target.nodeName === 'SELECT' ||
      event.target.nodeName === 'INPUT' ||
      event.target.className === 'form-control'
    ) {
      return;
    }

    onExpand(quoteId);
  };

  const cn = classNames('quote-line-wrapper', className);

  return (
    <QuotePostLineContext.Provider value={{ handleToggle, showDetails: expanded, hasSecondary, setHasSecondary }}>
      <div className={cn} {...rest}>
        {children}
      </div>
    </QuotePostLineContext.Provider>
  );
};

export default QuotePostLine;
